class Product extends Core {
	constructor() {
		super();
		const variantSelect = document.getElementById("product-variants"); // Select input <select/>
		const productForm = document.getElementById("product-form");
		const cardsHandle = productForm.getAttribute("data-cards-handle");
		const cardDefault = productForm.getAttribute("data-default-card");
		const crossSell = productForm.getAttribute("data-crosssell-tier");
		this.payload = {
			items: [],
			cartId: this.checkoutId,
			site: this.siteCode,
		};
		this.dataLayerNodes = [];
		this.selectedPrice = 0;
		this.selectedLiItems = [];
		this.selectedOptionItem = null;
		this.htmlProductEl = {
			optionGroups: Array.from(document.querySelectorAll(".options ul")),
			variantSelect,
			variantSelectOptions: variantSelect ? Array.from(variantSelect.options) : [],
			price: document.querySelector("#thePrice .price"),
			reducedPrice: document.querySelector("#thePrice .reduced"),
			submitButton: document.getElementById("form-submit"),
		};

		this.cardsHandle = cardsHandle && cardsHandle !== "false" ? cardsHandle : false;
		this.cardDefault = cardDefault && cardDefault !== "false" ? cardDefault : false;
		this.crossSell = crossSell && crossSell !== "false" ? crossSell : false;
	}

	isLoading(status) {
		if (status) {
			this.htmlProductEl.submitButton.setAttribute("disabled", true);
			this.htmlProductEl.submitButton.innerText = "loading...";
		} else {
			this.htmlProductEl.submitButton.removeAttribute("disabled");
			this.htmlProductEl.submitButton.innerText = "Send";
		}
	}

	setDefaultOption() {
		this.htmlProductEl.optionGroups.forEach((options) => {
			const firstElement = options.querySelector("li");
			firstElement.classList.add("selected");
			this.selectedLiItems.push(firstElement);
		});
		this.getSelectedOptions();
	}

	getSelectedOptions() {
		if (!this.htmlProductEl.variantSelectOptions.length === 0 || !Array.isArray(this.selectedLiItems)) return;

		// Build variant name from options selected
		const selectedVariantStr = this.selectedLiItems.map((item) => item.getAttribute("data-value")).join(" / ");

		// Cycle through variants and select matching one
		this.htmlProductEl.variantSelectOptions.forEach((option) => {
			// Select options <select>
			if (option.innerText.replace(/\s+/g, "") === selectedVariantStr.replace(/\s+/g, "")) {
				// Match = Selected option
				this.htmlProductEl.variantSelect.value = option.value;

				const price = parseFloat(option.getAttribute("data-price"));
				const compareAtPrice = parseFloat(option.getAttribute("data-compare-price")) || 0;

				this.selectedPrice = price;
				this.selectedOptionItem = option;

				this.dataLayerNodes.pop(); // remove previous variant selected
				this.dataLayerNodes.push(
					this.attributesToNode({
						title: option.getAttribute("data-product-name"),
						id: option.value,
						sku: option.getAttribute("data-sku"),
						variant: option.innerText,
						category: option.getAttribute("data-category"),
						productId: option.getAttribute("data-product-id"),
						currency: option.getAttribute("data-currency"),
						price,
					})
				);

				// Change price based on selected variant
				this.htmlProductEl.price.innerHTML = `${currencyFormat(price)} + Delivery`;
				this.calcDiffPrices();

				if (compareAtPrice && price < compareAtPrice) {
					this.htmlProductEl.reducedPrice.classList.remove("hide");
					this.htmlProductEl.reducedPrice.innerHTML = currencyFormat(compareAtPrice);
				} else {
					this.htmlProductEl.reducedPrice.classList.add("hide");
				}
			}
		});

		if (this.ga4Datalayer) this.ga4Datalayer.pushItems(this.dataLayerNodes, "view_item", null, true);
	}

	calcDiffPrices() {
		if (!this.htmlProductEl.variantSelectOptions.length === 0 || !Array.isArray(this.selectedLiItems)) return;

		// sanitizes values to be compared and clears the difference field values from selected elements
		const selectedValues = this.selectedLiItems.map((item) => {
			const itemDiffPriceEl = item.querySelector("span");
			itemDiffPriceEl.innerText = "";
			return item.getAttribute("data-value").replace(/\s+/g, "").toLowerCase();
		});

		const unselectedOptions = document.querySelectorAll(".options ul li:not(.selected)");

		// run through the variant options(select/options) and match with the options(li)
		// and then add the price difference on the unselected ones.
		this.htmlProductEl.variantSelectOptions.forEach((option) => {
			if (!option.selected) {
				const optionValues = option.innerText.split("/").map((v) => v.replace(/\s+/g, "").toLowerCase());
				if (optionValues.some((value) => selectedValues.includes(value))) {
					unselectedOptions.forEach((li) => {
						const liValue = li.getAttribute("data-value").replace(/\s+/g, "").toLowerCase();
						if (optionValues.includes(liValue)) {
							const itemDiffPriceEl = li.querySelector("span");
							const variantPrice = parseFloat(option.getAttribute("data-price"));
							const diff = variantPrice - this.selectedPrice;
							const signal = diff >= 0 ? "+" : "-";
							itemDiffPriceEl.innerText = `${signal} ${currencyFormat(Math.abs(diff))}`;
						}
					});
				}
			}
		});
	}

	// eslint-disable-next-line class-methods-use-this
	attributesToNode(attributes) {
		try {
			return {
				quantity: 1,
				merchandise: {
					id: attributes.id,
					sku: attributes.sku,
					title: attributes.variant,
					price: {
						amount: parseFloat(attributes.price),
						currencyCode: attributes.currency,
					},
					product: {
						id: attributes.productId,
						productType: attributes.category,
						title: attributes.title,
					},
				},
			};
		} catch (error) {
			console.log(error);
			return {};
		}
	}

	handleSelect(e) {
		try {
			e.preventDefault();
			const { currentTarget } = e;

			// Remove select from other elements
			const optionGroup = currentTarget.closest("ul");
			const groupItems = optionGroup.querySelectorAll("li");
			Array.from(groupItems).forEach((liItem) => {
				liItem.classList.remove("selected");
			});

			currentTarget.classList.add("selected");
			this.selectedLiItems = Array.from(document.querySelectorAll(".options ul li.selected"));

			// Select the variant option
			this.getSelectedOptions();
		} catch (error) {
			log("Product -> handleSelect", error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { context: this });
			}
		}
	}

	async handleSubmit(e) {
		if (e) e.preventDefault();
		this.isLoading(true);

		if (this.ga4Datalayer) this.ga4Datalayer.pushItems(this.dataLayerNodes, "add_to_cart");

		this.payload.items.unshift({
			merchandiseId: this.selectedOptionItem.value,
		});

		const addItemResult = await this.addItemsCart(this.payload);
		if (addItemResult.result) {
			const isValidCheckout = this.checkCheckoutValid();

			if (isValidCheckout.valid) {
				if (this.crossSell) {
					if (window.location.hostname === "localhost") {
						window.location = `/extras/${this.crossSell}`;
					} else {
						window.location = `/extras/${this.crossSell.toLowerCase()}`;
					}
				} else {
					// &skip_shop_pay=true -> It's an unofficial solution to avoid the default use of shop pay at checkout.
					window.location = `${this.checkoutObj.checkoutUrl}&skip_shop_pay=true`;
				}
			} else {
				window.location = "/cart/";
			}
		} else if (addItemResult.error) {
			showModal({
				txtHeader: "PROBLEM WITH BASKET!",
				htmlBody: this.apiErrorMessage(addItemResult.error),
			});
		} else {
			showModal(this.unexpectedError);
		}
		this.payload.items = [];
		this.isLoading(false);
	}

	async init() {
		try {
			// if sold out this will be unavailable
			if (!this.htmlProductEl.optionGroups.length > 0) return;

			// disable submit button
			this.isLoading(true);

			// fetch current checkout if available
			await this.fetchCheckout();

			// Show default option
			this.setDefaultOption();

			// Add event listeners
			this.htmlProductEl.optionGroups.forEach((optionGroup) => {
				const options = optionGroup.querySelectorAll("li");
				Array.from(options).forEach((option) => {
					option.addEventListener("click", this.handleSelect.bind(this), true);
				});
			});

			// initialize card selector if necessary and there isn't a card in the checkout
			if (!this.hasGreetingCard && this.cardsHandle && typeof CardEditor !== "undefined") {
				const cardEditor = new CardEditor({
					title: "Add a free <b>gift card</b>",
					saveBtnLabel: "Checkout",
					cardsUrl: `/cards/${this.cardsHandle}/index.html`,
					initialValues: {
						...(this.cardDefault && { cardSKU: this.cardDefault }),
					},
					onError: (err) => {
						log(err);
						if (typeof Rollbar === "object") {
							Rollbar.error(err.message, err);
						}
						this.htmlProductEl.submitButton.innerText = "Error!";
					},
					onSelect: (data) => {
						if (data.cardId && data.cardId !== "") {
							this.payload.items.push({
								merchandiseId: data.cardId,
								attributes: [
									...(!data.leaveBlank
										? [
												{ key: "_cardHeader", value: data.cardHeader },
												{ key: "_cardBody", value: data.cardBody },
												{ key: "_cardFooter", value: data.cardFooter },
												{ key: "_cardContent", value: data.cardTextContent },
										  ]
										: []),
									{
										key: "_bouquetSku",
										value: this.selectedOptionItem.getAttribute("data-sku"),
									},
								],
							});

							// add card data atributes for dataLayer
							if (data.dataAttributes) {
								this.dataLayerNodes.push(
									this.attributesToNode({
										title: data.dataAttributes.productTitle,
										id: data.dataAttributes.id,
										sku: data.dataAttributes.sku,
										variant: data.dataAttributes.variant,
										category: data.dataAttributes.productCategory,
										productId: data.dataAttributes.productId,
										price: data.dataAttributes.price,
										currency: data.dataAttributes.currency,
									})
								);
							}
						}
						this.handleSubmit();
					},
					readyCallback: (editor) => {
						this.htmlProductEl.submitButton.addEventListener("click", (e) => {
							e.preventDefault();
							editor.openSelector();
						});
					},
				});
				await cardEditor.createEditor();
			} else {
				this.htmlProductEl.submitButton.addEventListener("click", this.handleSubmit.bind(this));
			}

			this.isLoading(false);
		} catch (error) {
			log("Product -> init", error);
			if (typeof Rollbar === "object") {
				Rollbar.error(error.message, error, { context: this });
			}
		}
	}
}

window.addEventListener("load", () => {
	const product = new Product();
	product.init();

	// init carousel
	const carouselEl = document.querySelector(".carousel");
	if (carouselEl && typeof Carousel !== "undefined") {
		const carousel = new Carousel(carouselEl);
		carousel.setPlayOnce(true);
	}
});
